import { TextField } from "../../../atoms/Form";
import { type ConstructedTextField } from "../types";

export const FIELD_NAME_EMAIL = "email";
const SIMPLE_EMAIL_REGEX = /.+@.+\..+/;

const tLabel = "Email";
const tPlaceholder = "john@doe.com";

const tRequired = "Email required";
const tFormatEmail = 'Email must be of format "a@b.c"';
const tLengthEmail = 'Email must contain at least 5 characters, e.g. "a@b.c"';
const tLengthMax = "Email cannot exceed 200 characters";

export type EmailProps = ConstructedTextField;

export const Email = ({ textFieldProps, ...props }: EmailProps) => {
  return (
    <TextField
      name={FIELD_NAME_EMAIL}
      textFieldProps={{
        label: tLabel,
        placeholder: tPlaceholder,
        ...props,
        ...textFieldProps,
        inputProps: { maxLength: 200, ...textFieldProps?.inputProps },
      }}
      validate={(value, _, meta) => {
        if (props.required && meta?.modified && !value) {
          return tRequired;
        }

        if (meta?.dirty && value) {
          if (value.length < 5) {
            return tLengthEmail;
          }

          if (value.length > 200) {
            return tLengthMax;
          }

          if (!value.match(SIMPLE_EMAIL_REGEX)) {
            return tFormatEmail;
          }
        }

        return "";
      }}
    />
  );
};
